import React from "react";
import { Fallback } from "../Fallback";
import { BodyAsFormData } from "../../../services/utilities/util";
import FilterContext from "../../../routes/FilterContext";
import { apiMiddleware } from "../../../services/apis/apiMiddleware";
import { connect } from "react-redux";
import { filterDataFromUrl, Url } from "../../../services/utilities/util";
import { Link } from "react-router-dom";
import Preload from "image-preload";
Preload(["/edge/images/updated_logos/occupiedstock.svg"]);
function mapStateToProps(state) {
  return { filters: state.selectedFilters };
}

class OccupiedStock extends React.Component {
  static contextType = FilterContext;

  state = {
    isError: 0,
    occupiedArea: 0,
    filters: "",
    urlFilter: "",
  };

  componentDidMount() {
    //console.log();
    var filters;
    if (JSON.stringify(this.props.filters) == "{}") {
      filters = JSON.stringify(this.context.filters);
    } else {
      filters = JSON.stringify(this.props.filters);
    }
    this.state.filters = filters;
    apiMiddleware
      .post(
        "api/edge/office/get_dashboard_occupied_stock",
        BodyAsFormData(filters)
      )
      .then((res) => {
        if (res.status !== 200) {
          this.setState({ isError: 1 });
        } else {
          this.setState({
            occupiedArea: res.data.occupied_area,
          });
        }
      });

    if (Url.get.filter != undefined) {
      this.setState({
        urlFilter: "?filter=" + Url.get.filter,
      });
    } else {
      this.setState({
        urlFilter: "",
      });
    }
  }

  componentDidUpdate() {
    if (this.props.filters != this.state.filters) {
      this.setState({ filters: this.props.filters });

      apiMiddleware
        .post(
          "api/edge/office/get_dashboard_occupied_stock",
          BodyAsFormData(JSON.stringify(this.props.filters))
        )
        .then((res) => {
          if (res.status !== 200) {
            this.setState({ isError: 1 });
          } else {
            this.setState({
              occupiedArea: res.data.occupied_area,
            });
          }
        });

      if (Url.get.filter != undefined) {
        this.setState({
          urlFilter: "?filter=" + Url.get.filter,
        });
      } else {
        this.setState({
          urlFilter: "",
        });
      }
    }
  }

  render() {
    if (this.state.isError === 1) {
      return (
        <div className="col-lg-4 mb-4">
          <div className="widget">
            <div className="row">
              <Fallback />
            </div>
            <p className="widgetName">Occupied Stock</p>
          </div>
        </div>
      );
    }
    return (
      <Link to={`/office/region/${this.state.urlFilter}`} target="_blank">
        <div className="newWidgetClass">
          <img
            alt="OccupiedStock Icon"
            src="/edge/images/updated_logos/occupiedstock.svg"
            className="imgWidth100"
          />
          <div className="colorGreen">
            <h2>{this.state.occupiedArea} msf</h2>
            {/* <p>( )</p> */}
            <p>Occupied Stock</p>
          </div>
        </div>
      </Link>
    );
  }
}
export default connect(mapStateToProps)(OccupiedStock);
